// function toggleExpand(blockId) {
//     var block = document.getElementById(blockId);
//     block.classList.toggle('expanded');
// }

// function toggleExpandAndScroll(blockId) {
//     var block = document.getElementById(blockId);
//     var isExpanding = !block.classList.contains('expanded');
//     block.classList.toggle('expanded');

//     // Adjust scroll position only if expanding
//     if (isExpanding) {
//         setTimeout(function() {
//             var offset = 100; // Adjust the value as needed
//             var elementPosition = block.getBoundingClientRect().top;
//             var offsetPosition = elementPosition + window.pageYOffset - offset;
//             window.scrollTo({
//                 top: offsetPosition,
//                 behavior: "smooth"
//             });
//         }, 200);
//     }
// }

// function toggleScroll(blockId) {
//     var block = document.getElementById(blockId);
//     setTimeout(function() {
//         var offset = 100; // Adjust the value as needed
//         var elementPosition = block.getBoundingClientRect().top;
//         var offsetPosition = elementPosition + window.pageYOffset - offset;
//         window.scrollTo({
//             top: offsetPosition,
//             behavior: "smooth"
//         });
//     }, 200);
// }

// Store the currently open accordion
let currentlyOpenAccordion = null;

function toggleExpand(blockId) {
    const block = document.getElementById(blockId);
    const isExpanding = !block.classList.contains('expanded');
    const arrow = block.querySelector('svg');
    const expandableContent = block.querySelector('.expandable-content');
    
    // If there's already an open accordion and we're opening a new one, close the current one first
    if (currentlyOpenAccordion && currentlyOpenAccordion !== block && isExpanding) {
        // Close the currently open accordion
        closeAccordion(currentlyOpenAccordion);
    }
    
    // Toggle the clicked accordion
    if (isExpanding) {
        // Open this accordion
        openAccordion(block);
    } else {
        // Close this accordion
        closeAccordion(block);
    }
}

function openAccordion(accordion) {
    const expandableContent = accordion.querySelector('.expandable-content');
    const arrow = accordion.querySelector('svg');
    
    // First make it visible but with 0 height
    expandableContent.style.display = 'block';
    expandableContent.style.maxHeight = '0';
    expandableContent.style.opacity = '0';
    expandableContent.style.overflow = 'hidden';
    
    // Force a reflow to ensure the browser recognizes the element is visible
    void expandableContent.offsetWidth;
    
    // Now animate the height and opacity
    accordion.classList.add('expanded');
    expandableContent.style.maxHeight = expandableContent.scrollHeight + 'px';
    expandableContent.style.opacity = '1';
    expandableContent.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';
    
    // Rotate the arrow
    if (arrow) {
        arrow.style.transform = 'rotate(180deg)';
        arrow.style.transition = 'transform 0.3s ease';
    }
    
    // Set as current open accordion
    currentlyOpenAccordion = accordion;
    
    // After animation completes, set maxHeight to none to allow for dynamic content
    setTimeout(() => {
        expandableContent.style.maxHeight = 'none';
    }, 300);
}

function closeAccordion(accordion) {
    const expandableContent = accordion.querySelector('.expandable-content');
    const arrow = accordion.querySelector('svg');
    
    // First, temporarily set a specific maxHeight so we can animate it
    expandableContent.style.maxHeight = expandableContent.scrollHeight + 'px';
    expandableContent.style.overflow = 'hidden';
    
    // Force a reflow
    void expandableContent.offsetWidth;
    
    // Now animate closing
    accordion.classList.remove('expanded');
    expandableContent.style.maxHeight = '0';
    expandableContent.style.opacity = '0';
    expandableContent.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';
    
    // Reset arrow rotation
    if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
        arrow.style.transition = 'transform 0.3s ease';
    }
    
    // Clear current open accordion reference if this was it
    if (currentlyOpenAccordion === accordion) {
        currentlyOpenAccordion = null;
    }
    
    // After animation completes, set display to none
    setTimeout(() => {
        if (!accordion.classList.contains('expanded')) {
            expandableContent.style.display = 'none';
        }
    }, 300);
}

function toggleExpandAndScroll(blockId) {
    toggleExpand(blockId);
    scrollToElement(blockId);
}

function toggleScroll(blockId) {
    const block = document.getElementById(blockId);
    
    // If the block is a simple-text block and not expanded, expand it
    if (block.classList.contains('simple-text-block') && !block.classList.contains('expanded')) {
        toggleExpand(blockId);
    }
    
    scrollToElement(blockId);
}

function scrollToElement(blockId) {
    const block = document.getElementById(blockId);
    setTimeout(function() {
        const offset = 100;
        const elementPosition = block.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }, 100);
}

// Initialize all accordions when the page loads
document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('.simple-text-block');
    accordions.forEach(function(accordion) {
        const expandableContent = accordion.querySelector('.expandable-content');
        if (expandableContent) {
            expandableContent.style.display = 'none';
            expandableContent.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';
        }
        
        const arrow = accordion.querySelector('svg');
        if (arrow) {
            arrow.style.transition = 'transform 0.3s ease';
        }
    });
});